<div class="modal-header" [ngClass]="'priority-' + (announcement.priority || 'low')">
  <h5 class="modal-title">
    <i class="fa" [ngClass]="{
      'fa-info-circle': announcement.priority === 1 || announcement.priority === 0,
      'fa-exclamation-circle': announcement.priority === 2,
      'fa-exclamation-triangle': announcement.priority === 3
    }"></i>
    {{ announcement.title }}
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="ok()"></button>
</div>
<div class="modal-body">
  <div class="announcement-message" [innerHTML]="announcement.message | sanitizer:'html'"></div>
  @if (announcement.startDate || announcement.endDate) {
    <div class="announcement-dates">
      <small class="text-muted">
        Valido
        @if (announcement.startDate) {
          <span>dal {{ announcement.startDate | date:'short':'+0':'it' }}</span>
        }
        @if (announcement.endDate) {
          <span class="ms-1">fino al {{ announcement.endDate | date:'short':'+0':'it' }}</span>
        }
      </small>
    </div>
  }
</div>
<div class="modal-footer">
  <div class="form-check mr-auto">
    <input type="checkbox" class="form-check-input" id="dontShowAgain" [(ngModel)]="dontShowAgain">
    <label class="form-check-label" for="dontShowAgain">
      Non mostrare più questo avviso
    </label>
  </div>
  <button type="button" class="btn btn-primary" (click)="ok()">
    <i class="fa fa-check"></i> OK
  </button>
</div>
